import { Suspense } from "react";
import * as Sentry from "@sentry/react";
import { RouterProvider } from "react-router";
import { router } from "./routes";

function AppLoadingFallback() {
  return (
    <div className="min-h-screen bg-background px-6 py-16 text-foreground">
      <div className="mx-auto flex max-w-md flex-col gap-3 rounded-3xl border border-border/60 bg-card/80 p-6 shadow-sm">
        <div className="h-2 w-24 rounded-full bg-foreground/10" />
        <div className="h-2 w-40 rounded-full bg-foreground/10" />
        <div className="h-2 w-32 rounded-full bg-foreground/10" />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={<div className="min-h-screen bg-background p-6">예상치 못한 오류가 발생했습니다.</div>}>
      <Suspense fallback={<AppLoadingFallback />}>
        <RouterProvider router={router} />
      </Suspense>
    </Sentry.ErrorBoundary>
  );
}
